/* eslint-disable react/no-danger */
import React, { useState } from 'react';
import _, { isEmpty, map, chunk } from 'lodash';
import { Link } from 'gatsby';
import { motion } from 'framer-motion';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import BoxedContainer from './layouts/BoxedContainer';
import Sprites from '../components/Sprites';
import useMediaQuery from '../hooks/useMediaQuery';

export default function FreeZoneTitleTextWithTwoCards({ id, data, dir }) {
  const { title, text, backgroundImage, items, sectionID } = data;
  const [toggleStates, setToggleStates] = useState(Array(items.length).fill(false));
  const isDesktop = useMediaQuery('(min-width: 640px)');

  const handleToggle = (index) => {
    setToggleStates((prevState) => {
      const newState = [...prevState];
      newState[index] = !newState[index];
      return newState;
    });
  };

  return (
    <section
      id={sectionID || id}
      className="bg-[#F7F7F7] pt-[50px] md:pt-[100px] relative overflow-hidden">
      <BoxedContainer
        className="flex flex-col gap-y-10 md:gap-y-20 pb-[52px] md:pb-[100px]
      relative z-10">
        <motion.div
          initial={{ opacity: 0, y: 50 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.4, delay: 0.4 }}
          viewport={{ once: true }}
          className="flex flex-col gap-y-5 lg:gap-y-[30px]">
          <div className="flex flex-col gap-y-5">
            <div
              dangerouslySetInnerHTML={{ __html: title }}
              className="text-clamp20to40  h2-child:text-clamp20to40 text-[#231F20]
            h2-child:leading-1.2  text-center h2-child:!m-0"
            />
            <div className="h-[2px] w-[50px] md:w-[70px] bg-[#CE445B] mx-auto" />
          </div>
          <div
            dangerouslySetInnerHTML={{ __html: text }}
            className="p-child:text-[#4D4D4D] p-child:text-clamp12to18 p-child:font-normal
            p-child:leading-[1.6] p-child:mb-0 p-child:ltr:font-URWDINRegular
            p-child:rtl:font-GESSTwoDWTCLight text-center"
          />
        </motion.div>
        {isEmpty(items) || (
          <div className="flex flex-col lg:flex-row gap-10 md:gap-[30px]">
            {map(items, (item, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 40 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.3 * (index + 1), delay: 0.6 }}
                className="w-full lg:w-1/2">
                <div
                  className="max-h-[144px] md:max-h-[300px] overflow-hidden
                  lazy-load-image:!flex">
                  {isEmpty(item.content.packageImage) || (
                    <LazyLoadImage
                      src={item.content.packageImage.url}
                      width="100%"
                      effect="blur"
                      className="w-full h-full md:!block !hidden"
                      wrapperClassName="md:!block !hidden"
                    />
                  )}
                  {_.isEmpty(item.content.packageMobileImage)
                    ? _.isEmpty(item.content.packageImage) || (
                        <LazyLoadImage
                          src={item.content.packageImage.url}
                          alt={item.content.packageTitle}
                          width="100%"
                          effect="blur"
                          wrapperClassName="md:!hidden !block"
                          className="w-full h-full object-cover max-h-[150px] md:max-h-[472px] 
                          md:!hidden !block"
                        />
                      )
                    : _.isEmpty(item.content.packageMobileImage) || (
                        <LazyLoadImage
                          src={item.content.packageMobileImage.url}
                          alt={item.content.packageTitle}
                          width="100%"
                          effect="blur"
                          wrapperClassName="md:!hidden !block"
                          className="w-full h-full object-cover max-h-[150px] md:max-h-[472px]
                          md:!hidden !block"
                        />
                      )}
                </div>

                <div
                  className="flex flex-col gap-y-[25px] md:gap-y-[50px] bg-white border
                  border-[#ccc] p-4 pt-5 md:p-10 pb-5 rtl:md:pl-[60px] ltr:md:pr-[60px]">
                  <div className="flex flex-col gap-y-[26px] md:gap-y-10">
                    {isDesktop ? (
                      <h4
                        className="text-clamp14to25 ltr:font-LibreBaskervilleRegular
                        rtl:font-GESSTwoDWTCMedium  text-[#58595B]
                        leading-1">
                        {item.content.packageTitle}
                      </h4>
                    ) : (
                      <button
                        type="button"
                        className="w-full flex justify-between items-center gap-4"
                        onClick={() => handleToggle(index)}>
                        <h4
                          className="text-clamp14to25 ltr:font-LibreBaskervilleRegular
                      rtl:font-GESSTwoDWTCMedium  text-[#58595B]
                    leading-[1.4]">
                          {item.content.packageTitle}
                        </h4>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="12"
                          height="7"
                          viewBox="0 0 12 7"
                          fill="none"
                          data-toggle={toggleStates[index]}
                          className="transition data-[toggle=false]:rotate-180">
                          <path
                            d="M11 6L6 1L1 6"
                            stroke="#58595B"
                            strokeWidth="2"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                          />
                        </svg>
                      </button>
                    )}
                    {isEmpty(item.content.packageLists) || (
                      <div
                        data-toggle={isDesktop || toggleStates[index]}
                        className="flex flex-col md:flex-row gap-5 md:gap-10 data-[toggle=false]:hidden">
                        {chunk(
                          item.content.packageLists,
                          Math.ceil(item.content.packageLists.length / 2),
                        ).map((chunkData, chunkIndex) => (
                          <div key={chunkIndex} className="flex flex-col gap-y-5 md:w-1/2">
                            {map(chunkData, (packageLists, index1) => (
                              <div key={index1} className="flex flex-row gap-x-[15px] md:gap-x-5">
                                <Sprites
                                  name="tick"
                                  className="w-[15px] md:w-[25px] min-w-[15px] md:min-w-[25px]
                                  h-[15px] md:h-[25px] fill-[#CE445B] relative top-[2px] lg:top-[-4px]"
                                />
                                <span
                                className="text-clamp13to16 
                                ltr:font-URWDINRegular rtl:font-GESSTwoDWTCLight 
                                rtl:pt-[2px] rtl:md:pt-0
                                leading-[1.4]
                                text-[#4D4D4D]">
                                  {packageLists}
                                </span>
                              </div>
                            ))}
                          </div>
                        ))}
                      </div>
                    )}
                  </div>
                  {isEmpty(item.content.packageLink) || (
                    <div
                      data-toggle={isDesktop || toggleStates[index]}
                      className="data-[toggle=false]:hidden">
                      <Link
                        data-title={item.content.packageTitle}
                        href={item.content.packageLink.url}
                        className='card-cta w-fit flex 
                        justify-center items-center
                        rounded-[48px] bg-[#CE445B] text-white uppercase ltr:font-URWDINBold
                        rtl:font-GESSTwoDWTCMedium
                        ltr:tracking-[0.96px] leading-1 h-[36px] md:h-[49px] text-[11px]
                        md:text-[15px] hover:bg-[#B53B50] text-center ltr:pt-1 px-12 md:px-14'
                        dir={dir}>
                        {item.content.packageLink.name}
                      </Link>
                    </div>
                  )}
                </div>
              </motion.div>
            ))}
          </div>
        )}
      </BoxedContainer>
      {isEmpty(backgroundImage) || (
        <div className="absolute bottom-0 w-full lazy-load-image:!flex">
          <LazyLoadImage
            src={backgroundImage.url}
            width="100%"
            effect="blur"
            className="w-full h-full"
          />
        </div>
      )}
    </section>
  );
}

